// Alpine.js
import Alpine from 'alpinejs';
global.Alpine = Alpine;

// Import or define any Alpine components here
import './alpine-components/siteNav';
import './alpine-components/navDropdown';
Alpine.start();

import Swiper, { Navigation, Pagination } from 'swiper'; // eslint-disable-line
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';

import scrollMonitor from 'scrollmonitor';

// Lazy load images
import Lazyload from 'vanilla-lazyload';

// Create Lazy load instance
var lazyLoadInstance = new Lazyload({ // eslint-disable-line
    elements_selector: '.lazy'
    // ... more custom settings?
});

// Example of Babel.js transpiling
// Babel Input: ES2015 arrow function
[1, 2, 3].map((n) => n + 1);

// Babel Example: transpiling spread operator.
const test = { number: 1 }
const test2 = { ...test, somethingelse: 2 }

console.log(Date.now(), test2)

// ===================================================
// Image Sliders
// ===================================================
const imageSliders = document.querySelectorAll('[data-image-slider]');

imageSliders.forEach((item) => {

    new Swiper(item.querySelector('.swiper'), {
        slidesPerView: 1,
        centeredSlides: true,
        grabCursor: true,
        lazy: true,
        navigation: {
            nextEl: item.querySelector('.swiper-button-next'),
            prevEl: item.querySelector('.swiper-button-prev')
        },
        pagination: {
            el: item.querySelector('.swiper-pagination'),
            clickable: true,
        },
        modules: [Navigation, Pagination]
    });

});


// ===================================================
// About us page - Timeline
// ===================================================
let scrollDirection;
let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;

// element should be replaced with the actual target element on which you have applied scroll, use window in case of no target element.
document.addEventListener('scroll', function() { // or window.addEventListener("scroll"....
    var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
    if (st > lastScrollTop) {
        // downscroll code
        scrollDirection = 'down';
    } else if (st < lastScrollTop) {
        // upscroll code
        scrollDirection = 'up';
    } // else was horizontal scroll
    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}, false);



let at_end = false;
const timeline = document.querySelector('.timeline');
const timeline_rows = document.querySelectorAll('.timeline__row:not(.timeline-ignore)');

if (timeline) {

    const timeline_watcher = scrollMonitor.create(document.querySelector('.timeline'), { bottom: -scrollMonitor.viewportHeight });

    console.log(scrollMonitor.viewportHeight / -2)

    timeline_watcher.enterViewport(() => {

        if (scrollDirection === 'up') {
            at_end = false;
        }    

    });

    timeline_watcher.exitViewport(() => {
        if (!scrollDirection) {
            at_end = true;
            document.querySelector('.timeline').classList.add('is-swapped');
        }
    });

    timeline_rows.forEach((row, index) => {

        const date_col = row.querySelector('.timeline__date-col');
        const top_offset = scrollMonitor.viewportHeight / -2 - parseFloat(getComputedStyle(date_col).getPropertyValue('padding-top'));
        const row_watcher = scrollMonitor.create(row, { top: top_offset });

        row_watcher.enterViewport(() => {
            row.classList.add('is-active');
        });

        row_watcher.exitViewport(() => {
            row.classList.remove('is-active');
        });

        if (index === timeline_rows.length - 1) {

            const last_row_watcher = scrollMonitor.create(row);

            last_row_watcher.stateChange(() => {

                console.log('at_end: ', at_end)

                if (scrollDirection === 'down') {

                    if (last_row_watcher.isFullyInViewport) {

                        at_end = true;

                        row.closest('.timeline').classList.add('is-swapped');

                    }

                } else {

                    if (!at_end) {
                        row.closest('.timeline').classList.remove('is-swapped');
                    }

                }

            });

        }

    });

}